<template>
  <div :class="containerClass">
    <img :src="currentLogo" :style="logoStyle" :alt="logoAlt" />
    <h1 v-if="showTitle" class="text-xl font-bold" :style="{ color: titleColor }">
      {{ titleText }}
    </h1>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useColors } from 'vuestic-ui'
import { platform, backgroundColor, logo, title } from '../const'

const currentRoute = useRoute()
const { currentPresetName } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
    inline?: boolean
  }>(),
  {
    height: 48,
    start: 'primary',
    end: undefined,
    inline: false,
  },
)

const isLoginRoute = computed(() => {
  return currentRoute.name === 'login' || currentRoute.name == 'recover-password'
})

const currentLogo = computed(() => logo)

const logoAlt = computed(() => `${title} Logo`)

const showTitle = computed(() => platform === 'cn' || platform === 'tk')

const titleText = computed(() => title)

const titleColor = computed(() => backgroundColor)

const logoStyle = computed((): { [key: string]: string } => {
  if (isLoginRoute.value) {
    return {
      maxWidth: '500px',
      width: 'auto',
      height: 'auto',
      maxHeight: '180px',
      display: 'block',
      margin: '0 auto',
      objectFit: 'contain',
    }
  }
  return {
    width: 'auto',
    height: props.height + 'px',
    maxHeight: '48px',
    display: 'block',
    objectFit: 'contain',
  }
})

const containerClass = computed(() => {
  return props.inline ? 'flex items-center gap-3' : 'flex flex-col items-center gap-4'
})
</script>

<style scoped>
img {
  display: block;
  transition: all 0.3s ease;
  max-height: 48px; /* cap for very large contexts */
  height: auto;
}

@media (max-width: 1024px) {
  img {
    max-height: 40px;
  }
}

@media (max-width: 600px) {
  img {
    max-height: 28px;
    /* keep visible on small screens but smaller */
  }
}
</style>
